<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-data-table
        :headers="headers"
        :loading="isLoading"
        :items="customerDetailHead"
        :must-sort="false"
        class="elevation-0"
        hide-actions
      >
        <template v-slot:items="{ item: address }">
          <tr>
            <td>{{ address.number }}</td>
            <td>
              <address-name-format
                :names="[address.name1, address.name2, address.name3]"
              ></address-name-format>
            </td>
            <td>{{ address.clientLabel }}</td>
            <td>{{ address.customizationLabel }}</td>
            <td>{{ address.country }}</td>
          </tr>
        </template>
        <template v-slot:no-data>
          <div v-if="isLoading" style="text-align: center;">Please wait</div>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import AddressNameFormat from "@/components/AddressNameFormat.vue";

export default {
  name: "CustomerDetailHead",
  components: {
    AddressNameFormat
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "No.",
          sortable: false
        },
        {
          text: "Name",
          sortable: false
        },
        {
          text: "Client",
          sortable: false
        },
        {
          text: "Configuration",
          sortable: false
        },
        {
          text: "Country",
          sortable: false
        }
      ]
    };
  },
  computed: {
    ...mapGetters("admin", ["getCustomerDetailHead"]),
    alert() {
      return this.$store.state.admin.alert;
    },
    isLoading() {
      return this.$store.state.admin.loadingDetailHead;
    },
    customerDetailHead() {
      return this.getCustomerDetailHead ? [this.getCustomerDetailHead] : [];
    }
  },
  created() {
    this.$store.dispatch("admin/fetchCustomerDetailHead", {
      customerId: this.$route.params.customerId
    });
  }
};
</script>
